import { useEffect, useState } from 'react'
import { Routes, Route, Link, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useMediaQuery } from '@mui/material'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import '../assets/style/main.css'

import { Header } from '../components/header/Header'
import { Menu } from '../components/menu/Menu'

// import imgProyectos from '../components/menu/svg/Proyectos.svg';
// import imgHome from '../components/menu/svg/Home.svg';

import { iniLoadGeneralBudget, iniLoadAjustesDetail, iniGetInfoPropietaria, iniGetListaBancos, startGetGeneral } from '../redux/actions/general'

import { Home } from '../components/home/Home'
import { Dashboard } from '../components/dashboard/Dashboard'
import { DashboardPptos } from '../components/dashboard/DashboardPptos'
import { DashboardSales } from '../components/dashboard/sales/DashboardSales'
import { DashboardExpenses } from '../components/dashboard/expenses/DashboardExpenses'

// import { DashboardRentabilidad } from '../components/dashboard/DashboardRentabilidad'
// import { DashboardER } from '../components/dashboard/DashboardER'
// import { DashboardFacturacion } from '../components/dashboard/DashboardFacturacion'
// import { DashboardCobranza } from '../components/dashboard/DashboardCobranza'

import { ProjectsList } from '../components/projects/ProjectsList'
// import { ProjectsDetail } from '../components/projects/ProjectsDetail'

import { PptosList } from '../components/pptos/PptosLista'
// import { PptosListaPorAprobar } from '../components/pptos/PptosListaPorAprobar'
import { PptosListaAprobados } from '../components/pptos/PptosListaAprobados'

import { PptosForm } from '../components/pptos/form/PptosForm'

import { PptosGastosLista } from '../components/pptos_gastos/PptosGastosLista'
import { PptosGastosForm } from '../components/pptos_gastos/form/PptosGastosForm'

import { ComprasLista } from '../components/compras/ComprasLista'
import { ComprasForm } from '../components/compras/form/ComprasForm'

import { InvoiceList } from '../components/invoices/InvoiceList'
import { InvoiceForm } from '../components/invoices/form/InvoceForm'

import { CobrosList } from '../components/cobros/CobrosList'
import { PagosList } from '../components/pagos/PagosList'

import { CatalogListServicios } from '../components/catalog/CatalogListServicios'
import { ContactList } from '../components/contactos/ContactList'
// import { TasksList } from '../components/tasks/TasksList'

import { AjustesPptos } from '../components/ajustes/pptos/AjustesPptos'
import { AjustesGastos } from '../components/ajustes/AjustesGastos'

import { iniGetListSuppliers } from '../redux/actions/contacts'
import { iniGetListCustomers } from '../redux/actions/contacts'
import { iniGetListPersonas } from '../redux/actions/contacts'

// import { FacturasComprasLista } from './../components/facturas/facturas_compra/FacturasComprasLista'
// import { DetalleFacturaCompra } from './../components/facturas/facturas_compra/DetalleFacturaCompra'
import { GestionarCuentas } from '../components/gestionar_cuenta/GestionarCuentas'
import { InformacionPersonal } from '../components/gestionar_cuenta/InformacionPersonal'
import { NotificacionesHome } from './../components/notificaciones/NotificacionesHome'
// import { ProjectsTask } from '../components/projects/tasks/ProjectsTask'
import { BankAccounts } from '../components/bancos/BankAccounts'

import { HomeReportes } from '../components/reportes/HomeReportes'
// import { FlujoCaja } from '../components/reportes/FlujoCaja/FlujoCaja'
import { EstadoResultado } from '../components/reportes/EstadoResultado/EstadoResultado'
import { SupplierTracking } from '../components/reportes/suppliers/SupplierTracking'
import { CustomerTracking } from '../components/reportes/customers/CustomerTracking'
import { AccountsToCollect } from '../components/reportes/AccountsToCollect'
import { AccountsToPay } from '../components/reportes/AccountsToPay'
import { ExpensesToJustify } from '../components/reportes/ExpensesToJustify'
import { FlujoCajaNew } from '../components/reportes/FlujoCaja/FlujoCajaNew'
import { BankReconciliation } from '../components/bancos/BankReconciliation';
import { PptosListaAprobadosPorFacturar } from '../components/pptos/PptosListaAprobadosPorFacturar'
import { CatalogListCategorias } from '../components/catalog/CatalogListCategorias'
import { ComprasReport } from '../components/compras/ComprasReport'
import { TasksListNew } from '../components/tasks/TasksListNew'
// import { DragListExample } from '../components/tasks/DragExample/DragListExample'
import { FlujoEfectivo } from '../components/reportes/FlujoCaja/FlujoEfectivo'
import { ComprasListaVM1 } from '../components/compras/VM1/ComprasListaVM1'
import { VentasPorClientes } from '../components/reportes/ventas/VentasPorClientes'
import { VentasPorUnidadNegocio } from '../components/reportes/ventas/VentasPorUnidadNegocio'
import { VentasHistorico } from '../components/reportes/ventas/VentasHistorico'

import { TasksListNewMobile } from '../components/tasks/TasksListNewMobile'
import { OportunidadesHome } from '../components/oportunidades/newUI/OportunidadesHome'
import { FlowList } from '../components/flujos/FlowList'
import { Notificaciones } from '../components/notificaciones/new/Notificaciones'
import ImportPptos from '../components/imports/ImportPptos'
import { Banks } from '../components/bancos/Banks'
import { BankTransactions } from '../components/bancos/BankTransactions'
// import { TasksListNewMobil2 } from '../components/tasks/TasksListNewMobile2'


export const DashboardRoutes = () => {

    const dispatch = useDispatch();
    // const { perfil } = useSelector(state => state.auth);

    // const isMobile = useMediaQuery('(max-width:768px)');
    const isMobilePortrait = useMediaQuery("(max-width:768px) and (orientation: portrait)");
    const isMobileLandscape = useMediaQuery("(max-height:500px) and (orientation: landscape)");
    const isMobile = isMobilePortrait || isMobileLandscape;

    const [stateMenu, setStateMenu] = useState('');

    useEffect(() => {
        let statusSave = localStorage.getItem('stateMenu');
        if (statusSave) {
            return setStateMenu(statusSave)
        } else {
            if (isMobile) {
                setStateMenu('closed')
            } else {
                setStateMenu('all_open')
            }
        }
    }, [isMobile]);

    useEffect(() => {
        dispatch(iniLoadAjustesDetail());
    }, [dispatch])

    useEffect(() => {
        dispatch(iniGetInfoPropietaria());
    }, [dispatch])

    useEffect(() => {
        dispatch(startGetGeneral())
    }, [dispatch])

    useEffect(() => {
        dispatch(iniLoadGeneralBudget());
    }, [dispatch])

    useEffect(() => {
        dispatch(iniGetListSuppliers());
    }, [dispatch])

    useEffect(() => {
        dispatch(iniGetListCustomers());
    }, [dispatch])

    useEffect(() => {
        dispatch(iniGetListPersonas());
    }, [dispatch])

    useEffect(() => {
        dispatch(iniGetListaBancos());
    }, [dispatch])

    const handleSubmitMenu = () => {
        if (isMobile) {
            if (stateMenu === 'closed') {
                setStateMenu('all_open')
                localStorage.setItem('stateMenu', 'all_open');
            } else {
                setStateMenu('closed')
                localStorage.setItem('stateMenu', 'closed');
            }
        } else {
            if (stateMenu === 'all_open') {
                setStateMenu('medium_open')
                localStorage.setItem('stateMenu', 'medium_open');
            } else {
                setStateMenu('all_open')
                localStorage.setItem('stateMenu', 'all_open');
            }
        }
    }

    return (
        <div className="">

            <ToastContainer
                position="top-right"
                autoClose={2000}
                limit={1}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <Header
                stateMenu={stateMenu}
                setOpenMenu={handleSubmitMenu}
            />

            <div className='d-flex'>

                <Menu
                    isMobile={isMobile}
                    stateMenu={stateMenu}
                    setOpenMenu={handleSubmitMenu}
                />

                <div className={`
                ${!isMobile && 'p-4'} p-fn-content
                ${stateMenu === 'all_open' && 'ContainerSmall'}
                ${stateMenu === 'medium_open' && 'ContainerMedium'}
                ${stateMenu === 'closed' && 'ContainerLg'}
                `}>
                    <Routes>

                        {/* Gestinar cuenta */}
                        {/* <Route path="/gestionar_cuenta" element={<GestionarCuentas />} /> */}
                        <Route path="/informacion_personal" element={<InformacionPersonal />} />

                        <Route path="/inicio" element={<Home />} />
                        {/* <Route path="/inicio/resumen" element={<HomeResumen />} /> */}

                        {/* dashboard */}
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/dashboard/pptos" element={<DashboardPptos />} />
                        <Route path="/dashboard/ventas" element={<DashboardSales />} />
                        <Route path="/dashboard/gastos" element={<DashboardExpenses />} />

                        {/* <Route path="/dashboard/rentabilidad" element={<DashboardRentabilidad />} />
                        <Route path="/dashboard/er" element={<DashboardER />} />
                        <Route path="/dashboard/facturacion" element={<DashboardFacturacion />} />
                        <Route path="/dashboard/cobranza" element={<DashboardCobranza />} /> */}

                        {/* oportunidades */}
                        {/* <Route path="/oportunidades" element={<PptosList />} /> */}

                        {/* pptos por aprobar */}
                        <Route path="ppto" element={<PptosList />} />
                        <Route path='ppto/:budgetId' element={<PptosForm />} />
                        <Route path="ppto/imports" element={<ImportPptos />} />

                        {/* pptos aprobados */}
                        {/*                         <Route path="ppto/a" element={<PptosListaAprobados />} />
 */}

                        {/* proyectos */}
                        <Route path="projects/:budgetId" element={<PptosForm />} />
                        <Route path="projects" element={isMobile ? <ProjectsList /> : <PptosListaAprobados />} />
                        <Route path="projects/pf" element={<PptosListaAprobadosPorFacturar />} />

                        {/* pptos de gastos */}
                        <Route path="gastos/pptos" element={<PptosGastosLista />} />
                        <Route path='gastos/pptos/:budgetId' element={<PptosGastosForm />} />

                        {/* gastos */}
                        <Route path="gastos/report" element={<ComprasReport />} />
                        <Route path="gastos/compras" element={<ComprasLista />} />
                        <Route path='gastos/compras/:compraId' element={<ComprasForm />} />

                        <Route path="gastos/newg" element={<ComprasListaVM1 />} />

                        {/* facturas ventas */}
                        <Route path="facturas" element={<InvoiceList />} />
                        <Route path='facturas/:invoiceId' element={<InvoiceForm />} />

                        {/* flujos */}
                        <Route path="/flows" element={<FlowList />} />


                        {/* facturas compras */}
                        {/* <Route path='facturas/facturas_de_compras' element={<FacturasComprasLista />} />
                        <Route path='facturas/detalle_facturas_de_compras' element={< DetalleFacturaCompra />} /> */}

                        {/* catalogo */}
                        <Route path="catalogo" element={<CatalogListServicios />} />
                        <Route path="catalogo/cat" element={<CatalogListCategorias />} />

                        {/* contactos */}
                        <Route path="contactos" element={<ContactList />} />

                        {/* Tasks */}
                        {/* <Route path="tasks" element={<TasksList />} /> */}
                        {/*  <Route path="tasks" element={(isMobile || perfil === 9) ? <TasksListNewMobile /> : <TasksListNew />} /> */}
                        <Route path="tasks" element={isMobile ? <TasksListNewMobile /> : <TasksListNew />} />

                        {/* ajustes */}
                        <Route path="ajustes/cuenta" element={<GestionarCuentas />} />
                        {/* <Route path="ajustes/cuenta" element={<AjustesHome />} /> */}
                        <Route path="ajustes/pptos" element={<AjustesPptos />} />
                        <Route path="ajustes/gastos" element={<AjustesGastos />} />

                        {/* notificaciones */}
                        <Route path="notificacionesOld" element={<NotificacionesHome />} />
                        <Route path="notificaciones" element={<Notificaciones />} />

                        <Route path="banks" element={<Banks />} />
                        <Route path="banks/tra" element={<BankTransactions />} />
                        <Route path="banks/acc" element={<BankAccounts />} />
                        <Route path="banks/reconciliation" element={<BankReconciliation />} />
                        <Route path="banks/inc" element={<CobrosList />} />
                        <Route path="banks/exp" element={<PagosList />} />

                        <Route path="reportes" element={<HomeReportes />} />

                        {/* reportes Financieros */}
                        {/* <Route path="reportes/fc" element={<FlujoCaja showNav={true} mode="global" />} /> */}
                        <Route path="reportes/fcnew" element={<FlujoCajaNew showNav={true} mode="global" />} />
                        <Route path="reportes/fenew" element={<FlujoEfectivo showNav={true} mode="global" />} />
                        <Route path="reportes/er" element={<EstadoResultado />} />

                        {/* reportes ventas */}
                        <Route path="reportes/ventas/pc" element={<VentasPorClientes />} />
                        <Route path="reportes/ventas/un" element={<VentasPorUnidadNegocio />} />
                        <Route path="reportes/ventas/ph" element={<VentasHistorico />} />

                        {/* reportes clientes */}
                        <Route path="reportes/ct" element={<CustomerTracking />} />
                        <Route path="reportes/ac" element={<AccountsToCollect />} />

                        {/* reportes proveedores */}
                        <Route path="reportes/st" element={<SupplierTracking />} />
                        <Route path="reportes/ap" element={<AccountsToPay />} />
                        <Route path="reportes/ej" element={<ExpensesToJustify />} />

                        <Route path='crm' element={<OportunidadesHome />} />
                        {/* <Route path='orden-de-compra' element={<OrdenesCompraList />} />
                        <Route path='catalogo' element={<CatalogoList />} />
                        <Route path='ajustes' element={<Ajustes />} /> */}
                    </Routes>
                </div>
            </div>

            {isMobile ?
                <FooterMenu /> : ''
            }

            {/* {(isMobile) ?
                <FooterMenu /> : ''
            } */}

        </div>
    )

}

const FooterMenu = () => {

    const location = useLocation();
    const pathSelect = (path) => {
        const newPaths = location.pathname.split('/');
        if (newPaths[1] === path) return true;
        return false;
    };

    return (
        <div className='p-footer'>
            {/* <Link to='/inicio' className={`d-flex flex-column justify-content-center align-items-center ${pathSelect('inicio') && 'active-footer'}`}>
                <img src={imgHome} alt="Inicio" />
                <span>Inicio</span>
            </Link> */}
            <Link to='/projects' className={`d-flex flex-column justify-content-center align-items-center ${pathSelect('projects') && 'active-footer'}`}>
                {/* <img src={imgProyectos} alt="Proyectos" /> */}
                <i className="bi bi-folder-plus" style={{ fontSize: '18px', fontWeight: 'bold' }}></i>
                <span>Proyectos</span>
            </Link>
            <Link to='tasks' className={`d-flex flex-column justify-content-center align-items-center ${pathSelect('tasks') && 'active-footer'}`}>
                <i className="bi bi-list-task" style={{ fontSize: '18px', fontWeight: 'bold' }}></i>
                <span>Tareas</span>
            </Link>
        </div>
    )
}
